import React, { FC } from 'react'

type Props = {
  label: string
  data: Array<{
    id: number
    value: string
  }>
}

export const OptGroup: FC<Props> = ({ data, label }) => {
  if (!data.length) return null
  
  return (
    <optgroup label={label}>
      {data.map(i => (
        <option key={i.id} value={i.id}>{i.value}</option>
      ))}
    </optgroup>
  )
}